export default __webpack_public_path__ + "static/media/ai_wegic.db281d82b5b6195ad4ad720c1bfa05ac.svg";